@if (active().length > 0) {
  <div
    class="grid gap-1.5"
    cdkDropList
    cdkDropListLockAxis="y"
    (cdkDropListDropped)="drop($event)">
    @for (entry of active(); track entry.index) {
      <div
        cdkDrag
        cdkDragPreviewContainer="parent"
        class="[&.cdk-drag-preview]:bg-surface grid grid-cols-[18px_minmax(0,1fr)_150px_28px] items-center gap-2">
        <button
          #handle
          type="button"
          cdkDragHandle
          data-sort-handle
          class="text-text-tertiary hover:text-text-primary inline-flex h-[30px] cursor-grab items-center justify-center rounded-xs text-base transition-colors outline-none focus-visible:shadow-(--shadow-focus)"
          [attr.aria-label]="'features.data.path_filter.sort.reorder' | translate"
          (keydown)="onHandleKey($event, entry.index)">
          <i [class]="ICONS.dotsSixVertical" aria-hidden="true"></i>
        </button>
        <span
          class="border-default bg-elevated flex h-[30px] min-w-0 items-center gap-1.5 rounded-xs border px-2 text-[12.5px]">
          <span class="truncate" [id]="idPrefix + '-label-' + entry.index">{{
            entry.label
          }}</span>
          @if (entry.kpi) {
            <span class="text-text-tertiary ml-auto font-mono text-[11px]">{{
              'features.data.path_filter.sort.kpi' | translate
            }}</span>
          }
        </span>
        <app-select
          [id]="idPrefix + '-direction-' + entry.index"
          [labelledBy]="
            idPrefix +
            '-label-' +
            entry.index +
            ' ' +
            idPrefix +
            '-direction-' +
            entry.index
          "
          [items]="entry.directions"
          [value]="entry.order"
          (valueChange)="setOrder(entry.index, $event)" />
        <button
          type="button"
          data-sort-remove
          class="text-text-secondary hover:bg-interactive hover:text-text-primary inline-flex h-[30px] w-7 cursor-pointer items-center justify-center rounded-xs transition-colors"
          [attr.aria-label]="'features.data.path_filter.sort.remove' | translate"
          (click)="remove(entry.index)">
          <i [class]="ICONS.trash" aria-hidden="true"></i>
        </button>
      </div>
    }
  </div>
}

<input
  type="search"
  class="form-input rounded-xs px-2 py-1 text-[12.5px]"
  [placeholder]="'features.data.path_filter.sort.search' | translate"
  [attr.aria-label]="'features.data.path_filter.sort.search' | translate"
  [value]="query()"
  (input)="query.set($any($event.target).value)" />

@if (groups().length > 0) {
  <div class="border-weak overflow-hidden rounded-sm border">
    @for (group of groups(); track group.name) {
      <div
        data-sort-group
        class="bg-surface text-text-tertiary px-2.5 pt-1.5 pb-0.5 text-[11.5px]">
        {{ group.name }}
      </div>
      @for (match of group.options; track match.option.key) {
        <button
          type="button"
          data-sort-option
          class="border-weak hover:bg-accent-interactive flex w-full cursor-pointer items-center justify-between gap-2 border-t px-2.5 py-1.5 text-left text-[12.5px] transition-colors"
          (click)="add(match.option)">
          <span class="truncate"
            >{{ match.before }}<span class="font-semibold">{{ match.hit }}</span
            >{{ match.after }}</span
          >
          @if (match.option.kpi) {
            <span class="text-text-tertiary font-mono text-[11px]">{{
              'features.data.path_filter.sort.kpi' | translate
            }}</span>
          }
        </button>
      }
    }
  </div>
} @else {
  <p class="text-text-tertiary px-1 text-xs">
    {{ 'features.data.path_filter.sort.no_match' | translate }}
  </p>
}
